export default [
'80T118 Dux Proflo 80L Single Element 1.8kW',
'80T124 Dux Proflo 80L Single Element 2.4kW',
'80T136 Dux Proflo 80L Single Element 3.6kW',
'80T136H Dux Proflo 80L Single Element 3.6kW Hard Water',
'125T118 Dux Proflo 125L Single Element 1.8kW',
'125T118H Dux Proflo 125L Single Element 1.8kW Hard Water',
'125T136 Dux Proflo 125L Single Element 3.6kW',
'125T136H Dux Proflo 125L Single Element 3.6kW Hard Water',
'125X118 Dux Proflo 125L Narrow Diameter V-FIT Single Element 1.8kW',
'125X136 Dux Proflo 125L Narrow Diameter V-FIT Single Element 3.6kW',
'160T124 Dux Proflo 160L Single Element 2.4kW',
'160T124H Dux Proflo 160L Single Element 2.4kW Hard Water',
'160T136 Dux Proflo 160L Single Element 3.6kW',
'160T136H Dux Proflo 160L Single Element 3.6kW Hard Water',
'250T136 Dux Proflo 250L Single Element 3.6kW',
'250T136H Dux Proflo 250L Single Element 3.6kW Hard Water',
'315T136 Dux Proflo 315L Single Element 3.6kW',
'315T136H Dux Proflo 315L Single Element 3.6kW Hard Water',
'315T236 Dux Proflo 315L Twin Element 2 x 3.6kW',
'315T236H Dux Proflo 315L Twin Element 2 x 3.6kW Hard Water',
'315T248 Dux Proflo 315L Twin Element 2 x 4.8kW',
'315T248H Dux Proflo 315L Twin Element 2 x 4.8kW Hard Water',
'400T136 Dux Proflo 400L Single Element 3.6kW',
'400T236 Dux Proflo 400L Twin Element 2 x 3.6kW',
'135ZB4P Dux Prodigy 4 Star, 135L Propane',
'135ZB4N Dux Prodigy 4 Star, 135L Natural Gas',
'170ZB4P Dux Prodigy 4 Star, 170L Propane',
'170ZB4N Dux Prodigy 4 Star, 170L Natural Gas',
'D2FHG4HW0C Dux Heat Pump 250L Integrated Lid',
'D2M36F202 250L Ecosmart solar tank, 3.6kW element, 2 x 2m2 Collectors, Open Circuit',
'D3M36F202 315L Ecosmart solar tank, 3.6kW element, 2 x 2m2 Collectors, Open Circuit',
'D3M36F203 315L Ecosmart solar tank, 3.6kW element, 3 x 2m2 Collectors, Open Circuit',
'D4M36F202 400L Ecosmart solar tank, 3.6kW element, 2 x 2m2 Collectors, Open Circuit',
'D4M36F203 400L Ecosmart solar tank, 3.6kW element, 3 x 2m2 Collectors, Open Circuit',
'D2F20226N 250L Ecosmart solar tank, NG 26L/min Solar, 2x2m2 Collectors, Open Circuit',
'D2F20226L 250L Ecosmart solar tank, LPG 26L/min Solar, 2x2m2 Collectors, Open Circuit',
'D3F20226N 315L Ecosmart solar tank, NG 26L/min Solar, 2x2m2 Collectors, Open Circuit',
'D3F20226L 315L Ecosmart solar tank, LPG 26L/min Solar, 2x2m2 Collectors, Open Circuit',
'D3F20326N 315L Ecosmart solar tank, NG 26L/min Solar, 3x2m2 Collectors, Open Circuit',
'D3F20326L 315L Ecosmart solar tank, LPG 26L/min Solar, 3x2m2 Collectors, Open Circuit',
'D4F20226N 400L Ecosmart solar tank, NG 26L/min Solar, 2x2m2 Collectors, Open Circuit',
'D4F20226L 400L Ecosmart solar tank, LPG 26L/min Solar, 2x2m2 Collectors, Open Circuit',
'D4F20326N 400L Ecosmart solar tank, NG 26L/min Solar, 3x2m2 Collectors, Open Circuit',
'D4F20326L 400L Ecosmart solar tank, LPG 26L/min Solar, 3x2m2 Collectors, Open Circuit'
  ];
